import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContactFieldModel, ContactModel, EContactFieldType, EContactType} from '../../../../@models';
import {
  FormListContactFieldRenderComponent,
} from '../../form-list/renderer/form-list-contact-field-render.component';
import {NbToastrService} from '@nebular/theme';
import { CountryCodes, DocConfig, Incoterms } from '../../../../@models/erp/compilationData';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';


@Component({
    selector: 'ngx-form-list-contact-entry',
    templateUrl: './form-list-contact-entry.component.html',
    styleUrls: ['./form-list-contact-entry.component.scss']
})
export class FormListContactEntryComponent implements OnInit {
  @Input() item: ContactModel;
  @Input() items: ContactModel[];
  @Input() newItemOnTypeChange = true;
  @Output() itemChange: EventEmitter<ContactModel> = new EventEmitter<ContactModel>(); // TODO: make this work

  public contactTypes = EContactType;
  public field = EContactFieldType;

  public fieldColumns;
  public fieldtypemap: {value: number; title: string}[] = []; // from contacts

  public countryOptions = CountryCodes.getOptions();
  public incotermsOptions = Incoterms.getOptions();

  protected employeeOptions = [];
  protected emailOptions = [];

  docConfig = DocConfig;
  // storeOptions: {
  //   termsOfPaymentStore: { id: string, name: string }[],
  //   paymentTextStore: { id: string, name: string }[],
  // } = { termsOfPaymentStore: [], paymentTextStore: [] }

  constructor(private toastrService: NbToastrService, private api: ApiService, public data: SharedDataService) {

    for (const n in EContactFieldType) {
      if (typeof EContactFieldType[n] === 'number') {
        this.fieldtypemap.push({value: <any>EContactFieldType[n], title: n});
      }
    }

    this.fieldColumns = {
      type: {
        title: 'Type',
        type: 'custom',
        renderComponent: FormListContactFieldRenderComponent,
        editor: {
          type: 'list',
          config: {
            list: this.fieldtypemap,
          },
        },
        filter: false,
      },
      value: {
        title: 'Text',
        type: 'text',
        editor: {
          type: 'textarea',
        },
        filter: false,
      },
      /* comment: {
        title: 'Comment',
        type: 'text',
        editor: {
          type: 'textarea',
        },
      },*/
    };
  }

  async ngOnInit() {
    this.data.loadCompilationData();
    // const cd = await this.api.getCompilationData();
    // this.storeOptions.termsOfPaymentStore = cd.termsOfPaymentStore.map(m => ({ id: m, name:m }))
    // this.storeOptions.paymentTextStore = cd.paymentTextStore.map(m => ({ id: m, name:m }))
    this.employeeOptions = this.items.filter(f => f.type === EContactType.Employee).map(m => ({ id: m._id, name: m.title }));
    this.emailOptions = this.items.filter(f => f.fields?.find(f => f.type === EContactFieldType.Email)?.value).map(m => ({ id: m.fields.find(f => f.type === EContactFieldType.Email)?.value || '', name: m.title }));

    // console.log('employee options', this.employeeOptions);
  }

  typeChanged(type) {
    if (this.newItemOnTypeChange) {
      const newItem = this.items.find(f => +f.type === +type);
      // console.log('new item', this.items, type, newItem);
      if (newItem) this.item = newItem;
    } else {
      this.item.type = type;
    }
  }

  getFieldValue(type: number) {
    const field = this.item && this.item.fields && this.item.fields.find(f => +f.type === +type);
    return (field && field.value) || '';
  }

  setFieldValue(type: number, value: string) {
    const field = this.item && this.item.fields && this.item.fields.find(f => +f.type === +type);
    if (field) {
      field.value = value;
    } else if (this.item) {
      const newField = new ContactFieldModel();
      newField.type = +type;
      newField.value = value;
      if (!this.item.fields) this.item.fields = [];
      this.item.fields.push(newField);
    }
  }

  showAddressName() {
    return +this.item.type === EContactType.Delivery
    || +this.item.type  === EContactType.Invoice
    || +this.item.type === EContactType.Legal
    || +this.item.type === EContactType.PickUp;
  }

  isCountry(type: number) {
    return +type === +EContactFieldType.Country.valueOf()
      || +type === +EContactFieldType.IncotermsCountry.valueOf();
  }

  // isIncoterms(type: number) {
  //   return +type === +EContactFieldType.Incoterms.valueOf();
  // }

  // isTerms(type: number) {
  //   return +type === +EContactFieldType.PaymentConditions.valueOf();
  // }

  // isTermsText(type: number) {
  //   return +type === +EContactFieldType.PaymentText.valueOf();
  // }

  validate(event) {
    if (event.newData.value === '') {
      event.confirm.reject('Value is required');
      this.toastrService.danger('Value is required', 'Error');
    } else event.confirm.resolve();
  }

  doShowField(field) {
    switch (+this.item.type) {
      case EContactType.General:
        return field.value === EContactFieldType.Address2
        || field.value === EContactFieldType.Street
        || field.value === EContactFieldType.Zip
        || field.value === EContactFieldType.City
        || field.value === EContactFieldType.State
        || field.value === EContactFieldType.Country
        || field.value === EContactFieldType.Info
        || field.value === EContactFieldType.RegistrationNumber
        || field.value === EContactFieldType.VAT_Number
        || field.value === EContactFieldType.Phone
        || field.value === EContactFieldType.Fax
        || field.value === EContactFieldType.Email
        || field.value === EContactFieldType.Bank
        || field.value === EContactFieldType.IBAN
        || field.value === EContactFieldType.BIC
        || field.value === EContactFieldType.ReceptionHours
        || field.value === EContactFieldType.PaymentText
        || field.value === EContactFieldType.PaymentConditions
        || field.value === EContactFieldType.Incoterms
        || field.value === EContactFieldType.IncotermsPlace
        || field.value === EContactFieldType.IncotermsCountry
      case EContactType.Employee:
      case EContactType.ExEmployee:
        return  field.value === EContactFieldType.JobTitle
        || field.value === EContactFieldType.Phone
        || field.value === EContactFieldType.Mobile
        || field.value === EContactFieldType.BusinessLandline
        || field.value === EContactFieldType.Fax
        || field.value === EContactFieldType.Email
      case EContactType.Invoice:
        return field.value === EContactFieldType.Street
        || field.value === EContactFieldType.Zip
        || field.value === EContactFieldType.State
        || field.value === EContactFieldType.City
        || field.value === EContactFieldType.Country
        || field.value === EContactFieldType.Email
        || field.value === EContactFieldType.Info
        || field.value === EContactFieldType.VAT_Number
      case EContactType.InvoiceSendTo:
      case EContactType.DNSendTo:
      case EContactType.TCSendTo:
      case EContactType.OCSendTo:
      case EContactType.InvoiceReminder:
        return field.value === EContactFieldType.Street
        || field.value === EContactFieldType.Zip
        || field.value === EContactFieldType.State
        || field.value === EContactFieldType.City
        || field.value === EContactFieldType.Country
        || field.value === EContactFieldType.Email
        || field.value === EContactFieldType.Info
        || field.value === EContactFieldType.Instructions
        || field.value === EContactFieldType.SendingDate
        || field.value === EContactFieldType.SendingDays
        || field.value === EContactFieldType.SendMode

      case EContactType.Legal:
        return field.value === EContactFieldType.Street
        || field.value === EContactFieldType.Zip
        || field.value === EContactFieldType.State
        || field.value === EContactFieldType.City
        || field.value === EContactFieldType.Country
        || field.value === EContactFieldType.RegistrationNumber
        || field.value === EContactFieldType.VAT_Number
      case EContactType.Delivery:
      case EContactType.PickUp:
        return field.value === EContactFieldType.Street
        || field.value === EContactFieldType.Zip
        || field.value === EContactFieldType.State
        || field.value === EContactFieldType.City
        || field.value === EContactFieldType.Country
        || field.value === EContactFieldType.ReceptionHours
        || field.value === EContactFieldType.Incoterms
        || field.value === EContactFieldType.IncotermsPlace
        || field.value === EContactFieldType.IncotermsCountry
    }
  }

  storeValueChanged(type: number, value: string) {
    this.setFieldValue(type, value);
  }

  // async addStoreValue(store: string, type: number) {
  //   // eslint-disable-next-line max-len
  //   const cd = await this.api.saveCompilationData(store, this.getFieldValue(type), true);
  //   this.storeOptions[store] = cd[store].map(m => ({ id: m, name:m }))
  // }

  // async removeStoreValue(store: string, type: number) {
  //   // eslint-disable-next-line max-len
  //   const cd = await this.api.saveCompilationData(store, this.getFieldValue(type), false);
  //   this.storeOptions[store] = cd[store].map(m => ({ id: m, name:m }))
  // }
  /* change(item: ContactModel) {
    console.log(item);
    this.itemChange.emit(item);
  }*/

}
